module.exports = __webpack_public_path__ + "39f9399afe4e99afc7807a3614269ea6.svg";